import { useEffect } from 'react';
import { useSupabaseFolders } from '../hooks/useSupabaseFolders';
import { useSupabaseClients } from '../hooks/useSupabaseClients';
import { useSupabaseProjects } from '../hooks/useSupabaseProjects';
import { useSupabaseTeam } from '../hooks/useSupabaseTeam';

// Component to sync all Supabase data
function SupabaseSync() {
  useSupabaseFolders();
  useSupabaseClients();
  const { refetch: refetchProjects } = useSupabaseProjects();
  useSupabaseTeam();

  // Listen for manual refetch events
  useEffect(() => {
    const handleRefetch = () => {
      refetchProjects();
    };

    window.addEventListener('refetch-projects', handleRefetch);

    return () => {
      window.removeEventListener('refetch-projects', handleRefetch);
    };
  }, [refetchProjects]);

  return null; // This component doesn't render anything
}

export default SupabaseSync;

